<template>
  <div class="FDEEGG">
    <ListTitle :title="title" :titleImg="titleImg" h />
    <v-container fluid>
      <v-container class="pa-0">
        <v-breadcrumbs :items="breadItems" divider="/"></v-breadcrumbs>
      </v-container>
      <v-container class="px-12">
        <v-row class="d-flex justify-center align-center">
          <v-col>
            <div
              class="sect1-title mx-12 ct-text-h1 ct-text-bolder"
              style="text-align:center"
            >
              <span class="sectTitle2">團隊介紹</span>
            </div>
          </v-col>
        </v-row>
        <v-row
          class="d-flex flex-lg-nowrap justify-space-around align-center groupTab"
        >
          <v-col v-for="(list_item, index) in list" :key="index" sm="2">
            <div
              class="groupImg mx-auto"
              :id="'groupImg_' + index"
              role="tab"
              tabindex="0"
              :title="list_item.title"
              :aria-selected="index === idx ? 'true' : 'false'"
              @keypress="setItem(index)"
              @click="setItem(index)"
            >
              {{ list_item.title }}
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row
          aria-selected="true"
          class="d-flex justify-center white py-12"
          style="border-radius:10px"
        >
          <v-col cols="10" lg="10">
            <div
              class="content-wrapper"
              v-html="TOOL.replaceUnitToRem(item.content)"
            ></div>
          </v-col>
          <v-col cols="10" lg="10" sm="10" md="10">
            <div class="groupMemberTitle">現任成員介紹</div>
            <div
              class="groupMember"
              v-for="(member, memberIndex) in item.members"
              :key="memberIndex"
              :class="{
                groupMemberType:
                  memberIndex > 0 &&
                  member.character !== item.members[memberIndex - 1].character
              }"
            >
              <div class="col-sm-5 col-3" style="margin-right: 10px;">
                <img
                  :src="SYS.setImg(member)"
                  :alt="member.name + member.jobTitle + '照片'"
                  class="memberImg"
                />
              </div>
              <div class="col-7">
                <div class="groupMemberCategory">
                  {{ member.character }}
                </div>
                <div class="groupMemberName">{{ member.name }}</div>
                <div>
                  <table style="border-spacing: 0 10px;">
                    <tbody>
                      <tr class="groupMemberDetail">
                        <td class="groupMemberDetailTitle">職稱：</td>
                        <td>{{ member.jobTitle }}</td>
                      </tr>
                      <tr
                        class="groupMemberDetail"
                        v-if="
                          member.expertise !== '' && member.expertise !== null
                        "
                      >
                        <td class="groupMemberDetailTitle">專長：</td>
                        <td>{{ member.expertise }}</td>
                      </tr>
                      <tr
                        v-if="
                          member.assistant !== '' && member.assistant !== null
                        "
                      >
                        <td class="groupMemberDetailTitle">助理：</td>
                        <td>{{ member.assistant }}</td>
                      </tr>
                      <tr
                        class="groupMemberDetail"
                        v-if="member.tel !== '' && member.tel !== null"
                      >
                        <td class="groupMemberDetailTitle">電話：</td>
                        <td>{{ member.tel }}</td>
                      </tr>
                      <tr
                        class="groupMemberDetail"
                        v-if="member.email !== '' && member.email !== null"
                      >
                        <td class="groupMemberDetailTitle">EMAIL：</td>
                        <td>{{ member.email }}</td>
                      </tr>
                      <tr
                        class="groupMemberDetail"
                        v-if="member.comment !== '' && member.comment !== null"
                      >
                        <td class="groupMemberDetailTitle">備註說明：</td>
                        <td v-html="TOOL.replaceUnitToRem(member.comment)"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="10" lg="10" sm="10" md="10">
            <div class="groupAssistantTitle">現任工作夥伴</div>
            <div class="groupAssistant">
              <div
                class="ma-auto"
                v-for="(assistant, assistantIndex) in item.assistants"
                :key="assistantIndex"
              >
                <div class="avatar-img">
                  <img
                    :src="SYS.setImg(assistant)"
                    :alt="assistant.name + assistant.jobTitle + '照片'"
                    class="memberImg"
                  />
                </div>
                <div class="groupAssistantName">
                  {{ assistant.name + " " + assistant.jobTitle }}
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="10" lg="10" sm="10" md="10">
            <v-data-table
              :items="item.contacts"
              :headers="consultationHeader"
              hide-default-footer
              class="ct_datatable"
            >
              <template v-slot:item.text="{ item }">
                <template v-if="item.url !== null && item.url !== ''">
                  <a
                    :href="item.url"
                    :title="`${item.content}(另開新視窗)`"
                    target="_blank"
                    class="consultationLink"
                    >{{ item.content }}
                    <img
                      :src="require(`@/assets/images/announce/mdi_link.png`)"
                      alt=""
                  /></a>
                </template>
                <template v-else>
                  {{ item.content }}
                </template>
              </template>
            </v-data-table>
          </v-col>
          <v-col
            cols="10"
            lg="10"
            sm="10"
            md="10"
            v-if="item.oldMembers && item.oldMembers.length > 0"
          >
            <div class="groupMemberTitle">歷屆成員</div>
            <v-data-table
              :items="item.oldMembers"
              :headers="oldMemberHeader"
              hide-default-footer
              class="ct_datatable"
            ></v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
export default {
  props: {
    title: {
      type: String,
      default: "愛樹教育輔導團"
      // default: "五區環境教育輔導團"
    },
    titleImg: {
      type: String,
      default: "common/icon_FDEEGG.svg"
    }
  },
  components: {
    Footer,
    ListTitle
  },
  data() {
    return {
      idx: 0,
      list: [],
      breadItems: [
        {
          text: "最新消息",
          disabled: false,
          to: "/Announce/"
        },
        {
          text: "愛樹教育輔導團",
          // text: "五區環境教育輔導團",
          disabled: true
          // href: "breadcrumbs_link_2"
        }
      ],
      item: {
        category: 1,
        title: "標題",
        onlineDate: Date.now(),
        content: "內容"
      },
      consultationHeader: [
        {
          text: "諮詢窗口",
          value: "text",
          align: "left",
          scope: "col",
          sortable: false
        }
      ],
      oldMemberHeader: [
        {
          text: "姓名",
          value: "name",
          align: "left",
          scope: "col",
          sortable: false
        },
        {
          text: "服務年分",
          value: "serviceYear",
          align: "left",
          scope: "col",
          sortable: false
        }
      ]
    };
  },
  methods: {
    getFDEEGGList() {
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Announce/GetFDEEGGList`
      }).then(resp => {
        if (resp.status === 200) {
          if (
            typeof resp.data.data !== "undefined" &&
            resp.data.data !== null
          ) {
            if (resp.data.data.length > 0) {
              this.list = resp.data.data;
              setTimeout(() => {
                this.setItem(0);
              }, 100);
            }
          }
        }
      });
    },
    setItem(idx) {
      let old_doc = document.getElementById("groupImg_" + this.idx);
      let doc = document.getElementById("groupImg_" + idx);
      if (old_doc != null) {
        old_doc.classList.remove("active");
        old_doc.classList.remove("groupText");
      }
      this.idx = idx;
      this.item = this.list[this.idx];
      if (doc != null) {
        doc.classList.add("active");
        doc.classList.add("groupText");
      }
    }
  },
  mounted() {
    this.getFDEEGGList();
  }
};
</script>
<style lang="scss" scoped>
.FDEEGG {
  background-color: #f6edd9;
}

.groupTab {
  margin-top: 30px;
  margin-bottom: 30px;
}

.groupImg {
  cursor: pointer;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  width: 208px;
  @include pad {
    width: 100px;
  }
  @include phone {
    width: 50px;
  }
  text-align: center;
  opacity: 0.3;
  position: relative;
  &.active {
    opacity: 1;
    // @include pc {
    &::before {
      content: "";
      position: absolute;
      bottom: -60px;
      @include pad {
        bottom: -58px;
      }
      @include phone {
        bottom: -60px;
      }
      width: 106px;
      right: calc(50% - 53px);
      height: 56px;
      border-style: solid;
      border-width: 0 53px 36px 53px;
      border-color: transparent transparent white transparent;
    }
    // }
  }
}
.groupText {
  color: #009568;
  border-bottom: 2px solid #009568;
  padding-top: 6px;
  padding-bottom: 6px;
}
.groupMemberTitle {
  color: #2f4b3b;
  line-height: 1;
  padding: 1rem 0;
  font-size: 2.25rem;
  font-weight: bold;
  @include pad {
    font-size: 1.75rem;
  }
  @include phone {
    font-size: 1.25rem;
  }
}
.groupMember {
  display: flex;
  justify-content: flex-start;
  background-color: #f7f7f6;
  padding: 3vh 0 3vh 3vw;
  @include phone {
    flex-direction: column; /* 垂直排列子元素 */
    justify-content: center; /* 垂直居中 */
  }
}
.groupMemberType {
  margin-top: 10px;
}
// .groupMember .left {
//   width: 30%;
//   @include pad {
//     width: 50%;
//   }
//   @include phone {
//     width: 70%;
//   }
// }
// .groupMember .right {
//   @include pad {
//     width: 60%;
//   }
// }
.groupMemberCategory {
  width: 20%;
  min-width: 140px;
  min-height: 40px;
  line-height: 40px;
  color: white;
  white-space: nowrap;
  text-align: center;
  background-color: #009568;
  font-size: 1.25rem;
  @include pad {
    font-size: 1rem;
  }
  @include phone {
    margin: 10px 0 10px 0;
    font-size: 0.875rem;
  }
}
.groupMemberName {
  font-size: 1.75rem;
  font-weight: bold;
  margin: 10px 0 10px 0;
  @include pad {
    font-size: 1.25rem;
  }
  @include phone {
    font-size: 1rem;
  }
}
.groupMemberDetail {
  font-size: 1.25rem;
  margin: 5px 0 5px 0;
  @include pad {
    font-size: 1rem;
  }
  @include phone {
    font-size: 0.875rem;
  }
}
.groupMemberDetailTitle {
  width: 20%;
  vertical-align: top;
  text-align: left;
}
.memberImg {
  width: 100%;
  height: auto;
  border-radius: 15px;
}
.groupAssistantTitle {
  color: #2f4b3b;
  line-height: 1;
  padding: 0;
  font-size: 1.75rem;
  font-weight: bold;
  @include pad {
    font-size: 1.5rem;
  }
  @include phone {
    font-size: 1.25rem;
  }
}
.groupAssistant {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  background-color: #f7f7f6;
  margin: 10px 5px 10px 5px;
  @include phone {
    flex-direction: column;
    justify-content: center;
  }
}
.ma-auto {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 14%;
  box-sizing: border-box;
  margin: 10px !important;
  @include phone {
    width: 60%;
    margin: auto !important;
  }
}
.avatar-img {
  width: 100%;
  margin: 5px;
}
.groupAssistantName {
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
}
.ct_datatable table thead tr th span {
  color: #2f4b3b;
}
.consultationLink {
  color: #009568;
  text-decoration: none;
}
</style>
